/**
 * Termly Cookie Banner – Text Override
 *
 * Hooks into the Termly embed script's onload event, waits for the banner DOM
 * to render, then replaces the message text with Cardinal Financial's approved copy.
 * Uses a MutationObserver to re-apply if Termly's framework re-renders the banner.
 *
 * Interim solution until Termly provides dashboard-level copy editing.
 * To disable: remove the wp_enqueue_script call in enqueue.php.
 */
(function () {
  var CUSTOM_MESSAGE =
    'We use cookies and other analytic technologies on this website to optimize your experience, ' +
    'analyze traffic and for our advertising purposes. By continuing to use this site, you agree to the ' +
    'terms of our <a href="https://www.cardinalfinancial.com/privacy-policy/" target="_blank" id="ca_privacy_url">Privacy Policy</a>, including our use of technologies that ' +
    'analyze and monitor activity on our website, and may record your activity on this site for tailored advertising and other purposes. Click \u201cAccept\u201d or continue browsing to accept.';

  var MAX_POLL_RETRIES = 40;
  var POLL_INTERVAL_MS = 250;
  var OBSERVER_TIMEOUT_MS = 30000;

  function isAlreadyCustomized(el) {
    return el.innerHTML.indexOf('ca_privacy_url') !== -1;
  }

  function customizeBanner() {
    var messageEl = document.querySelector('[class*="termly-styles-message"]');
    if (messageEl && !isAlreadyCustomized(messageEl)) {
      messageEl.innerHTML = CUSTOM_MESSAGE;
      return messageEl;
    }
    return messageEl;
  }

  function startObserver() {
    var target = document.querySelector('#termly-code-snippet-support') || document.body;

    var observer = new MutationObserver(function () {
      customizeBanner();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);
  }

  function pollForBanner(retriesLeft) {
    var found = customizeBanner();
    if (found) {
      startObserver();
      return;
    }
    if (retriesLeft > 0) {
      setTimeout(function () {
        pollForBanner(retriesLeft - 1);
      }, POLL_INTERVAL_MS);
    }
  }

  function init() {
    pollForBanner(MAX_POLL_RETRIES);
  }

  var termlyScript = document.querySelector(
    'script[src*="app.termly.io/resource-blocker"]'
  );

  if (termlyScript) {
    termlyScript.addEventListener('load', function () {
      setTimeout(init, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
